import * as React from "react";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { Tabs, useMediaQuery } from "@mui/material";
import Eventboxtab from "./Eventboxtab";
import PressReleasetab from "./PressReleasetab";
import Videoboxtab from "./Videoboxtab";

const ExploreMore = () => {
  const mediumViewport = useMediaQuery("(min-width:768px)");
  const [value, setValue] = React.useState("2");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <div className="  pt-5 pb-5 tabred">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <h4 className="d-block m-0 fw-bold text-uppercase text-center mb-3">
              <span className="txtred">Newsroom</span>{" "}
              {/* <span className="txtdgray">More</span> */}
            </h4>
          </div>

          <div className="mt-3"></div>
          <div className='container custom-card'>
            <div className='d-flex align-items-center mb-3 custom-card-headers'>
              <div className='text-uppercase me-2'>
                <h4 className='d-inline-block m-0 fw-bold'>

                  <span className='txtred'>WHAT'S NEW</span>

                </h4>
              </div>
              <div className='flex-grow-1 position-relative bg-border-mid'></div>

            </div>
            <PressReleasetab />
          </div>

          <div className="mt-5"></div>
          <div className='container custom-card'>
            <div className='d-flex align-items-center mb-3 custom-card-headers'>
              <div className='text-uppercase me-2'>
                <h4 className='d-inline-block m-0 fw-bold'>

                  <span className='txtred'>EVENTS</span>

                </h4>
              </div>
              <div className='flex-grow-1 position-relative bg-border-mid'></div>

            </div>
            <Eventboxtab />
          </div>

          <div className="mt-5"></div>
          <div className='container custom-card'>
            <div className='d-flex align-items-center mb-3 custom-card-headers'>
              <div className='text-uppercase me-2'>
                <h4 className='d-inline-block m-0 fw-bold'>
                  <span className='txtred text-uppercase'>Testimonials</span>
                </h4>
              </div>
              <div className='flex-grow-1 position-relative bg-border-mid'></div>

            </div>
          <Videoboxtab />
          </div>

        </div>
      </div>
    </div>
  );
};

export default React.memo(ExploreMore);
